// extracted by mini-css-extract-plugin
export default {"Box":"archive-header-wrapper-module__Box--W9s7N","Box_1":"archive-header-wrapper-module__Box_1--v68Sg"};